module.exports = __webpack_public_path__ + "static/media/6.c016ede0.jpg";